export default "https://cdn-static.gokick.com/assets/faf4ec4796b5499b7477edf17656e3681d9dd642/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";